import { jsx as _jsx } from "react/jsx-runtime";
import Slider from "react-slick";
export const Carousel = (props) => {
    const { settings, setSliderRef, children } = props;
    return (_jsx(Slider, Object.assign({ ref: setSliderRef }, settings, { children: children })));
};
//# sourceMappingURL=carousel.js.map